exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Home_text_3ds5 {\n  font-size: 21px;\n\n  color: #fff;\n  background: #f3766c;\n}\n\n.Home_text-content_19OD {\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap: 8px;\n\n  -webkit-box-pack: justify;\n\n  -webkit-justify-content: space-between;\n\n      -ms-flex-pack: justify;\n\n          justify-content: space-between;\n}\n", ""]);

// exports
exports.locals = {
	"text": "Home_text_3ds5",
	"text-content": "Home_text-content_19OD"
};